import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from '@mantine/core'

const NotFoundPage: React.FC = () => {
  const history = useHistory()

    return (
        <div className="flex flex-col items-center justify-center min-h-screen gap-4">
              <h1 className="text-6xl font-bold text-gray-400">404</h1>
                    <p className="text-xl text-gray-600">Page not found.</p>
                          <Button onClick={() => history.push('/')}>Go to Dashboard</Button>
                              </div>
                                )
                                }

                                export default NotFoundPage
                                